<lumiron-section class="contact">
  <lumiron-section-header>
    <lumiron-section-title>Kontakt</lumiron-section-title>
    <lumiron-section-summary>
      Bei Fragen sind wir gerne für dich da! Checkt auch unser
      <a [routerLink]="'/kontakt'" [fragment]="'faq'">FAQ</a>
      aus - vielleicht findet sich da schon die Antwort, die du suchst!
    </lumiron-section-summary>
  </lumiron-section-header>

  <lumiron-section-body class="address">
    <lumiron-card>
      <lumiron-card-body>
        <div>
          <p class="label"><i class="bi bi-geo-alt"></i>Adresse</p>
          <p>{{ business.legalName }}</p>
          <p>{{ business.street }}</p>
          <p>{{ business.postalCode }} {{ business.city }}</p>
        </div>
      </lumiron-card-body>
    </lumiron-card>

    <lumiron-card class="contact-devices">
      <lumiron-card-body>
        <div>
          <p class="label"><i class="bi bi-envelope"></i>Email</p>
          <a class="email" [href]="'mailto:' + business.email">{{ business.email }}</a>
          <p class="label"><i class="bi bi-telephone"></i>Telefon / WhatsApp</p>
          <a class="phone" [href]="'tel:' + business.phoneE164">{{ business.phoneDisplay }}</a>
        </div>
      </lumiron-card-body>
    </lumiron-card>

    <lumiron-card class="contact-form">
      <lumiron-card-header>
        <lumiron-card-title>Kontaktformular</lumiron-card-title>
      </lumiron-card-header>

      <lumiron-card-body>
        <form [formGroup]="contactForm" class="contact-form">
          <div>
            <label for="nameInput" class="form-label">Name *</label>
            <input type="text" class="form-control" id="nameInput" formControlName="name" />
          </div>
          <div>
            <label for="emailInput" class="form-label">E-Mail *</label>
            <input type="email" class="form-control" id="emailInput" formControlName="email" />
          </div>
          <div>
            <label for="phoneInput" class="form-label">Telefon</label>
            <input type="tel" class="form-control" id="phoneInput" formControlName="phone" />
          </div>
          <div>
            <label for="subjectInput" class="form-label">Betreff *</label>
            <input type="text" class="form-control" id="subjectInput" formControlName="subject" />
          </div>
          <div class="message">
            <label for="messageInput" class="form-label">Nachricht *</label>
            <textarea class="form-control" id="messageInput" rows="3" formControlName="message"></textarea>
          </div>

          <lumiron-button
            [disabled]="
              !contactForm.valid || sendingMessage()
            "
            (click)="sendContactForm()"
          >
            @if (sendingMessage()) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span role="status">senden...</span>
            } @else { Nachricht senden }
          </lumiron-button>
        </form>
      </lumiron-card-body>
    </lumiron-card>
  </lumiron-section-body>
</lumiron-section>

<lumiron-section id="faq" class="faq">
  <lumiron-section-header>
    <lumiron-section-title>FAQ</lumiron-section-title>
  </lumiron-section-header>

  <lumiron-section-body>
    <lumiron-accordion></lumiron-accordion>
  </lumiron-section-body>
</lumiron-section>
